import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-28" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-28" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-28" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      label: _ctx.$t('bookingShipment.column.detailShipment')
    }, null, 8, ["label"]),
    (_ctx.isSttRetail)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 0,
          class: "w-12/12 sm:w-6/12",
          label: _ctx.$t('bookingShipment.payment.title'),
          value: _ctx.checkoutPaymentMethod
        }, null, 8, ["label", "value"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('bookingShipment.column.noStt'),
        value: _ctx.detailData.sttNo,
        class: "w-12/12 sm:w-4/12"
      }, null, 8, ["label", "value"])
    ]),
    (_ctx.detailData.sttShipmentId)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 1,
          label: _ctx.$t('bookingShipment.column.shipmentId'),
          value: _ctx.detailData.sttShipmentId,
          class: "w-12/12 sm:w-6/12"
        }, null, 8, ["label", "value"]))
      : _createCommentVNode("", true),
    (_ctx.detailData.sttClient?.clientName)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 2,
          label: _ctx.$t('bookingShipment.detail.createdFor'),
          value: _ctx.detailData.sttClient?.clientName,
          class: "w-12/12 sm:w-6/12"
        }, null, 8, ["label", "value"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataWrapper, {
      class: "w-12/12 sm:w-6/12",
      label: _ctx.$t('bookingShipment.column.districtOriginCity'),
      value: _ctx.detailData.sttOriginAddress
    }, null, 8, ["label", "value"]),
    _createVNode(_component_DataWrapper, {
      class: "w-12/12 sm:w-6/12",
      label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
      value: _ctx.detailData.sttDestinationAddress
    }, null, 8, ["label", "value"]),
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bookingShipment.column.externalRefNumber'),
      value: _ctx.detailData.sttNoRefExternal,
      class: "w-12/12 sm:w-6/12"
    }, null, 8, ["label", "value"]),
    _hoisted_3,
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bookingShipment.column.shipperName'),
      value: _ctx.detailData.sttSenderName
    }, null, 8, ["label", "value"]),
    _createVNode(_component_DataWrapper, {
      class: "w-12/12 sm:w-6/12",
      label: _ctx.$t('bookingShipment.detail.shipperAddress'),
      value: _ctx.detailData.sttSenderAddress
    }, null, 8, ["label", "value"]),
    (_ctx.isShowInfoDetail)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 3,
          class: "w-12/12 sm:w-6/12",
          label: _ctx.$t('bookingShipment.detail.shipperPhoneNumber'),
          value: `${_ctx.detailData.sttSenderPhoneCode}${_ctx.detailData.sttSenderPhone}`
        }, null, 8, ["label", "value"]))
      : (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 4,
          label: _ctx.$t('bookingShipment.detail.shipperPhoneNumber')
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["label"])),
    _hoisted_5,
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bookingShipment.column.recipientName'),
      value: _ctx.detailData.sttRecipientName
    }, null, 8, ["label", "value"]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_DataWrapper, {
        class: "w-12/12 sm:w-6/12",
        label: _ctx.$t('bookingShipment.detail.recipientAddress'),
        value: _ctx.detailData.sttRecipientAddress
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        class: "w-6/12 sm:w-6/12",
        label: _ctx.$t('bookingShipment.column.postalCode'),
        value: _ctx.detailData.postalCodeDestination
      }, null, 8, ["label", "value"])
    ]),
    (_ctx.isShowInfoDetail)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 5,
          label: _ctx.$t('bookingShipment.detail.recipientPhoneNumber'),
          value: 
        `${_ctx.detailData.sttRecipientPhoneCode}${_ctx.detailData.sttRecipientPhone}`
      ,
          class: "w-12/12 sm:w-6/12"
        }, null, 8, ["label", "value"]))
      : (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 6,
          label: _ctx.$t('bookingShipment.detail.recipientPhoneNumber')
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["label"])),
    (_ctx.isShowInfoDetail)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 7,
          label: _ctx.$t('bookingShipment.detail.addressType'),
          value: _ctx.addressType
        }, null, 8, ["label", "value"]))
      : (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 8,
          label: _ctx.$t('bookingShipment.detail.addressType')
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["label"]))
  ]))
}